import {CSSProperties, ReactNode} from "react";
import Divider from "./Divider";

interface LabelWrapperProps {
    label: ReactNode | ReactNode[] | string;
    children?: ReactNode | ReactNode[];
    sticky?: string;
    style?: CSSProperties
}

export default function LabelWrapper({children, label, sticky, style = {}}: LabelWrapperProps) {
    return (
        <div className={sticky + " bg-white py-2 rounded-3 mb-3"} style={{...style, "zIndex": "0"}}>
            <Divider>
                {label}
            </Divider>
            {children}
        </div>
    )
}